/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Retry_ButtonInputs */

const en_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry Connection`)
};

const fr_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer la Connexion`)
};

const de_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung erneut versuchen`)
};

const it_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova la connessione`)
};

const ru_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить попытку подключения`)
};

const es_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar la conexión`)
};

const zh_cn2_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试连接`)
};

const ja_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続を再試行する`)
};

const hi_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्शन पुनः प्रयास करें`)
};

const pt_pt2_offline_retry_button = /** @type {(inputs: Offline_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente a conexão`)
};

/**
* | output |
* | --- |
* | "Retry Connection" |
*
* @param {Offline_Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_retry_button = /** @type {((inputs?: Offline_Retry_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Retry_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_retry_button(inputs)
	if (locale === "de") return de_offline_retry_button(inputs)
	if (locale === "it") return it_offline_retry_button(inputs)
	if (locale === "ru") return ru_offline_retry_button(inputs)
	if (locale === "es") return es_offline_retry_button(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_retry_button(inputs)
	if (locale === "ja") return ja_offline_retry_button(inputs)
	if (locale === "hi") return hi_offline_retry_button(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_retry_button(inputs)
	return en_offline_retry_button(inputs)
});